<template>
  <el-dialog class="user_model_dialog" top="5vh" center :title="newTitle" :append-to-body="true" width="70%" :before-close="handleClose"
             :visible.sync="dialogVisible" :close-on-click-modal="false">
    <el-form v-loading="loading.dialog" size="mini" ref="form" :rules="rules" :model="form">
      <div style="display: flex;">
        <el-form-item  label="菜单名称" prop="menu_name" :label-width="formLabelWidth">
          <el-input v-model="form.menu_name" autocomplete="off" :disabled="!isEdit"></el-input>
        </el-form-item>
        <el-form-item label="菜单类型" prop="menu_type" :label-width="formLabelWidth">
          <el-select size="mini" autocomplete="off" v-model="form.menu_type" @change='(val)=>getDevOpsSpaceSettingMenuParent(val,true)' collapse-tags filterable placeholder="请选择类型">
            <el-option v-for="(key, value) in allType" :key="key" :label="key" :value="value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item  label="菜单编码" prop="menue_code" :label-width="formLabelWidth">
          <el-input v-model="form.menue_code" autocomplete="off" :disabled="!isEdit"></el-input>
        </el-form-item>
      </div>
      <div style="display: flex;">
        <el-form-item  label="上级菜单" prop="parent_id" :label-width="formLabelWidth">
          <el-select  filterable collapse-tags size="mini" v-model="form.parent_id" :disabled="!isEdit"  placeholder="请选择上级菜单" style="width: 200px;">
            <el-option v-for="(key, value) in allParentMenu" :key="key" :label="key" :value="value" />
          </el-select>
        </el-form-item>
        <el-form-item  label="路径" prop="devops_url" :label-width="formLabelWidth">
          <el-input v-model="form.devops_url" autocomplete="off" :disabled="!isEdit"></el-input>
        </el-form-item>
        <el-form-item  label="图标" prop="icon" :label-width="formLabelWidth">
          <el-input v-model="form.icon" autocomplete="off" :disabled="!isEdit"></el-input>
        </el-form-item>
      </div>
     <div style="display: flex;">
      <el-form-item label="状态" prop="menu_stats" :label-width="formLabelWidth">
          <el-switch v-model="form.menu_stats" :disabled="!isEditOrCreate" active-color="#11a983" inactive-color="#f5f7fa" active-value="1" inactive-value="0">
          </el-switch>
        </el-form-item>
      <el-form-item label="权限控制" prop="access_check" :label-width="formLabelWidth">
        <el-switch v-model="form.access_check" :disabled="!isEdit" active-color="#11a983" inactive-color="#f5f7fa" active-value="1" inactive-value="0">
        </el-switch>
      </el-form-item>
    </div>
      <div v-if="form.access_check == 1">
      <el-form-item label="角色赋权" prop="access_check_role" :label-width="formLabelWidth" label-position="left">
        <el-select  filterable  clearable multiple size="mini" v-model="form.access_check_role"  placeholder="请选择角色" :disabled="!isEdit"  style="width: 80%">
          <el-option v-for="(key, value) in allRoles" :key="key" :label="key" :value="value" />
        </el-select>
      </el-form-item>
      <el-form-item label="人员赋权" prop="access_check_user" :label-width="formLabelWidth" label-position="left">
        <el-select  filterable  clearable multiple size="mini" v-model="form.access_check_user"  placeholder="请选择人员" :disabled="!isEdit"  style="width: 80%">
          <el-option v-for="(key, value) in allUser" :key="key" :label="key" :value="value" />
        </el-select>
      </el-form-item>
      </div>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button v-if="isEdit" :loading="loading.submit" type="primary"  @click="onSubmit">保存</el-button>
      <el-button type="success" @click="handleClose">关 闭</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { formatEnToUtf8, formatTimeToDate } from "@/views/tops/devOps/components/util.js";
import {
  getDevOpsSpaceSettingMenuDetailApi, getDevOpsSpaceSettingMenuTypeApi,
  getDevOpsSpaceTeamDetaililApi,
  getDevOpsSpaceUserDetailApi,
  getDevOpsSpaceUserRoleListApi, postDevOpsSpaceAddMenuApi,
  postDevOpsSpaceAddTeamApi,
  postDevOpsSpaceCreateDemandApi,
  postDevOpsSpaceEditDemandApi, postDevOpsSpaceUpdateMenuApi, postDevOpsSpaceUpdateTeamApi,
  postDevOpsSpaceUpdateUserApi
} from "@/server/tops/devOps";
import { mapState } from "vuex";
import {getDevOpsSpaceAllUserListApi} from "@/server/tops/base";
export default {
  components: {},
  props: {
    formInfo: {
      type: Object,
      default: function () {
        return {}
      },
    },
    dialogVisible: {
      type: Boolean,
      default: function () {
        return false
      }
    },
    hideDialogVisible: {
      type: Function,
      default: function () {
        return () => { }
      }
    },
    showDialogVisible: {
      type: Function,
      default: function () {
        return () => { }
      }
    },
    isEdit:{
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      form: {
        menu_name: '',
        menu_type: '1',
        menue_code: '',
        parent_id: '',
        menu_stats: '1',
        access_check: '0',
        access_check_role: [],
        access_check_user: [],
        allRoles: [],
      },
      rules: {
        menu_name: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        menu_type: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        menue_code: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        teamMates: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
      },
      formLabelWidth: '135px',
      loading: {
        dialog: false,
        submit: false,
      },
      allRoles: [],
      allUser:[],
      allType:{'1':'一级菜单','2':'二级菜单','3':'按钮'},
      allParentMenu: [],
    };
  },
  async mounted() {
    const { menu_id = ''} = this.formInfo;
    const username = this.$store.state.devOps.userInfo.devops_name? this.$store.state.devOps.userInfo.devops_name : '';
    const userId = this.$store.state.devOps.userInfo.userId? this.$store.state.devOps.userInfo.userId : '';

    this.form = { ...this.form,menuId:menu_id}
    this.$set(this.form, 'username', username)
    this.username = username;
    this.$nextTick(async () => {
      await this.getDevOpsSpaceAllUser();
      if(menu_id) await this.init(menu_id)
      await this.getDevOpsSpaceSettingMenuParent(this.form.menu_type);
      await this.getUserRoleList();

    })
  },
  computed: {
    ...mapState(
        {
          allSelect: (state) => state.devOps.ALLSELECT,
        }
    ),
    // 部分不可编辑
    isProjectDisabled() {
      return true;
    },
    newTitle() {
      if (this.form.menuId) {
        return '编辑菜单';
      } else {
        return '新增菜单'
      }
    },
    isEditOrCreate(){
      if(!this.form.menuId){
        return false;
      }
      if(this.isEdit){
        return this.isEdit;
      }

      return false;
    },
  },
  methods: {
    getDate() {
      var now = new Date().getTime();
      return now;
    },
    changeSwitch(v){
      console.log(v);
    },
    async getDevOpsSpaceAllUser(){
      const ret = await getDevOpsSpaceAllUserListApi();
      let arr = {};
      if(ret.status === 'success'){
        ret.data.forEach((item,index)=>{
          if(item.user_type !== 1 && item.user_type !== 13){
            arr[item.id] = item.user_name;
          }
        });
      }
      this.allUser = arr;
    },
    // 获取详情
    async init(id) {
      this.loading.dialog = true
      try {
        const ret = await getDevOpsSpaceSettingMenuDetailApi({ menuId:id });
        const info = ret.data[0] || {};
        this.form = {
          ...this.form,
          ...info,
          menu_type: info.menu_type.toString(),
          menu_stats: info.status.toString(),
          parent_id: info.parent_id == 0 ? '':info.parent_id.toString(),
          access_check_role: info.role ? info.role.split(',') : [],
          access_check_user: info.user ? info.user.split(',') : [],
          access_check: info.access_check.toString(),

        }
      } catch (error) {
        this.$notify({
          message: error || "数据错误",
          type: "error",
        })
      } finally {
        this.loading.dialog = false
      }

    },
    // 获取上级菜单
    async getDevOpsSpaceSettingMenuParent(menu_type,resParent = false) {
      this.loading.dialog = true
      try {
        if(resParent){
          this.form.parent_id = '';
        }
        const ret = await getDevOpsSpaceSettingMenuTypeApi({ menu_type:menu_type });
        let arr = {};
        ret.data.forEach((item)=>{
          arr[item.id] = item.menu_name;
        })
        this.allParentMenu = arr;
      } catch (error) {
        this.$notify({
          message: error || "数据错误",
          type: "error",
        })
      } finally {
        this.loading.dialog = false
      }

    },
    // 提交
    async onSubmit(close = true) {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          if(this.form.access_check == 1){
            if(this.form.access_check_role.length < 1 && this.form.access_check_user.length < 1 ){
              this.$notify({
                message: "角色赋权和人员赋权必填一项",
                type: "error",
              })
              return false;
            }
          }

          this.moduleSubmit(close)
        }
      });
    },
    async moduleSubmit(close = true){
      try {
        close && this.$set(this.loading, 'submit', true)
        const {
          menu_name = "",
          menu_type = "",
          menue_code = "",
          parent_id = "",
          menu_stats = "",
          access_check = "",
          access_check_role = [],
          access_check_user = [],
          menuId = '',
          devops_url = '',
          icon = '',
        } = this.form;
        const param = { ...this.form,access_check_role:access_check_role.toString(), access_check_user:access_check_user.toString(),menu_type:Number(menu_type),parent_id:Number(parent_id),menu_stats:Number(menu_stats),menuId:Number(menuId),access_check:Number(access_check),devops_url,icon};
        // id 存在 更新 不存在 创建
        const ret = this.form.menuId ? await postDevOpsSpaceUpdateMenuApi(param) : await postDevOpsSpaceAddMenuApi(param);
        if (ret.status === 'success') {
            this.$notify({
              message: ret.message || '提交成功',
              type: "success",
            })
            setTimeout(() => {
              this.handleClose()

            }, 500)
        } else {
          this.$notify({
            message: ret.message || "失败",
            type: "error",
          })
        }
      } catch (error) {
        this.$notify({
          message: error || "网络错误",
          type: "error",
        })
      } finally {
        this.loading.submit = false;
      }
    },
    async getUserRoleList(){
      let arr = {};
      await  getDevOpsSpaceUserRoleListApi().then((ret)=>{
        ret.data.forEach((item)=>{
          arr[item.id] = item.name;
        })
      })
      this.allRoles = arr;
    },
    // 关闭弹窗
    handleClose(step) {
      this.hideDialogVisible(step)
    },
    // 将多个英文名转换为中文
    formatEnToUtf8,
    formatTimeToDate,
  }
};
</script>
<style lang="scss">
.user_model_dialog {
  .comment_warp {
    .comment_item>div {
      display: flex;
      margin: 0;
      margin-bottom: 12px;

      .el-textarea__inner {
        font-weight: bold;
      }
    }
  }

  .table_text_click {
    text-decoration: underline;
    color: #409EFF;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  .table_text_no_click {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  .el-dialog__body {
    padding-bottom: 0;
  }
  .el-form-item__content {
    line-height: 16px;
  }
  .el-form-item__label {
    font-weight: bold;
    font-size: 12px;
  }
}

.popperDom {
  max-width: 240px;
}
</style>
